import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-wrapper" }
const _hoisted_2 = { class: "content" }

import PageTitle from '@/components/UI/PageTitle.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'PageViews',
  setup(__props) {

console.log("Ore wa ochinchin ga daysuki nandayo?!")

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PageTitle, { titleElement: '' }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_view)
      ])
    ])
  ], 64))
}
}

})